import React from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';

import {labels} from '../../../../util/utils';
import {engagementStatuses} from '../../../../util/uiconstants';
import Utility from '../../../../util/utilityfunctions';

import OutputText from '@ey/canvascoreservices/OutputText';

import CountWithTooltip from '../CountWithTooltip';
import StyledCustomItem from './StyledCustomItem';

const EngagementsCount = () => {
	const orgChart = useSelector(({orgChart}) => orgChart);
	const isGroupProject = useSelector(({project}) => project?.isGroupRiskAssessmentProject);
	const engagementMeta = useSelector(({engagementMetaData}) => engagementMetaData);

	const getEngagementList = () =>
		engagementMeta?.map(({description, engagementId, engagementStatus}) => ({
			description:
				isGroupProject && engagementStatus === engagementStatuses.Archived
					? `(${engagementStatus}) ${description}`
					: description,
			engagementId
		})) || [];

	const getCountEngagements = () => {
		let eng = orgChart?.flatMap((org) => org.engagements);
		return new Set(eng).size;
	};

	const renderItem = ({engagementId, description}, index) => {
		return (
			<StyledCustomItem key={index} type="container">
				<OutputText ellipsis title={description}>
					{description}
				</OutputText>
				<OutputText body2 light title={engagementId} ellipsis>
					{engagementId}
				</OutputText>
			</StyledCustomItem>
		);
	};

	const props = {
		inactiveLabel: `${labels.of.replace('{num}', getCountEngagements())}`,
		activeLabel: ` ${labels.countEngagements(getCountEngagements())}`,
		countLabel: labels.engagementsLabel,
		itemList: Utility.sortListData([...getEngagementList()], 'description'),
		customItemRender: renderItem,
		sideBarMode: true
	};

	return <CountWithTooltip {...props} />;
};

EngagementsCount.propTypes = {
	isClassicProject: PropTypes.bool
};

EngagementsCount.defaultProps = {
	isClassicProject: true
};

export default EngagementsCount;
